export default (state = {
    fetched: false,
    attributes: [],
    requireVariantUpdate: false,
    has_variants: false,
    submittingForm: false,
    selectOptions:[],
    seller:{
        handling_times:[],
        shipping_delivery_options_list:[],
        addresses:[]
    }
}, action) => {

    switch (action.type) {
        case 'FETCHING_PRODUCT_FORM' :
            return {
                ...state,
                fetched: false
            };
        case 'FETCHING_PRODUCT_FORM_FAILED' :
            return {
                ...state,
                fetched: 0
            };
        case 'FETCH_PRODUCT_FORM' :
            return {
                ...state,
                ...action.results,
                fetched: true
            };
        case 'PRODUCT_FORM_REQUIRE_VARIANT_UPDATE' :
            return {
                ...state,
                requireVariantUpdate: action.status
            };
        case 'EDIT_PRODUCT_UPDATE_VARIANT_INDEXES' :
            return {
                ...state,
                variantsIndexes: action.variants
            };
        case 'PRODUCT_FORM_UPDATE_HAS_VARIANTS' :
            return {
                ...state,
                has_variants: action.status
            }
        case 'PRODUCT_FORM_SUBMITTING_FORM' :
            return {
                ...state,
                submittingForm: action.status
            }
        default:
            return state;
    }
};